import { render } from "./gallery-video.vue?vue&type=template&id=7798f72e&scoped=true"
const script = {}

import "./gallery-video.vue?vue&type=style&index=0&id=7798f72e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7798f72e"]])

export default __exports__